import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleBaseService {
  constructor(private http: HttpClient) {}

  letterList(): string[] {
    return;
  }

  getCarbrand(code: string): Observable<any> {
    return;
  }

  getCarSeries(parentId: string): Observable<any> {
    return;
  }

  getCarModels(seriesId: string): Observable<any> {
    return;
  }
}
